import { Form, Input, InputNumber, message, Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useGwGoodsTypeSubUpdateQuery, useGwGoodsTypeSubUpdateSaveMutation } from '../../store/ReactWebSiteApi';

function SonTypeEdit(props) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState();
    const editForm = useRef()
    const {data,isSuccess} = useGwGoodsTypeSubUpdateQuery({eowgts_id:props.eowgts_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);
                editForm.current.setFieldsValue({
                    eowgts_name:data.Result.eowgts_name,
                    eowgts_content:data.Result.eowgts_content,
                    eowgts_serial_number:data.Result.eowgts_serial_number,
                })
                setInfo(prevState=>({...prevState,
                    eowgts_name:data.Result.eowgts_name,
                    eowgts_content:data.Result.eowgts_content,              
                    eowgts_keyid:data.Result.eowgts_keyid,              
                    eowgts_serial_number:data.Result.eowgts_serial_number,
                }))
            }
        }
    },[data,isSuccess])
    const [submitUpdateSave] = useGwGoodsTypeSubUpdateSaveMutation()
    return (
        <>
            <a  onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                open={open}
                title='修改企业类型'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    submitUpdateSave({
                        eowgts_name:info.eowgts_name,
                        eowgts_e_id:localStorage.getItem('e_id'),
                        eowgts_update_uid:localStorage.getItem('eu_id'),
                        eowgts_update_uname:localStorage.getItem('eu_name'),
                        eowgts_id:props.eowgts_id,
                        eowgts_eowgt_id:props.eowgt_id,
                        eowgts_serial_number:info.eowgts_serial_number,
                    }).then((res) => {
                        console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 7 }}
                    ref={editForm}
                >
                    <Form.Item name="eowgts_name" label='企业类型名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,eowgts_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="eowgts_serial_number" label='序号' wrapperCol={{span:10}} required>
                        <InputNumber  onChange={(e) => {setInfo(prevState=>({...prevState,eowgts_serial_number:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default SonTypeEdit